import { getObjectChildRelationships } from "../../redux/reducers/objectSlice";
import { useAppSelector } from "../../redux/stateHooks";
import FilterByIdInsideCrossFilter from "./filterByIdInsideCrossFilter";

function CrossFilter({ title, crossFilters, setCrossFilters }) {
  const childRelationShip = useAppSelector(getObjectChildRelationships);

  const handleRelationChange = (index, event) => {
    let tempCrossFilter = JSON.parse(JSON.stringify(crossFilters));
    tempCrossFilter[index].withOrWithout = event.target.value;
    setCrossFilters([...tempCrossFilter]);
  };
  const handleChildrenChange = (index, event) => {
    let tempCrossFilter = JSON.parse(JSON.stringify(crossFilters));
    tempCrossFilter[index].childSObject = event.target.value;
    let children = childRelationShip.find(
      (x) => x.childSObject == event.target.value
    );
    tempCrossFilter[index].field = children.field;
    tempCrossFilter[index].relationshipName = children.relationshipName;
    tempCrossFilter[index].filters = [
      { field: "", operator: "", value: "", type: "" },
    ];
    setCrossFilters([...tempCrossFilter]);
  };
  const handleChildrenRemove = (index) => {
    if (crossFilters.length == 1) return;
    // console.log(index);
    let tempCrossFilters = crossFilters.filter((_, i) => i !== index);
    setCrossFilters([...tempCrossFilters]);
  };
  const handleAddCrossFilterField = (index) => {
    // console.log(index);
    let tempCrossFilter = JSON.parse(JSON.stringify(crossFilters));
    tempCrossFilter[index].filters.push({
      field: "",
      operator: "",
      value: "",
      type: "",
    });
    setCrossFilters([...tempCrossFilter]);
  };
  return (
    <>
      {!!crossFilters.length && (
        <div>
          <p>Cross Filter</p>
        </div>
      )}
      <ul>
        {crossFilters.map((filter, index) => (
          <li key={index} className="d-flex flex-wrap">
            <div className="full-width d-flex">
              <div className="col1">
                <span className="number">&nbsp;</span>
              </div>
              <div className="coll col2">
                <div className="custom-dropdown">
                  <select className="form-control">
                    <option value={title}>{title}</option>
                  </select>
                </div>
              </div>
              <div className="coll col3">
                <div className="custom-dropdown">
                  <select
                    value={filter.withOrWithout}
                    className="form-control"
                    onChange={(event) => handleRelationChange(index, event)}
                  >
                    <option value="">Select Relation</option>
                    <option value="with">with</option>
                    <option value="without">without</option>
                  </select>
                </div>
              </div>
              <div className="coll col4">
                <div className="custom-dropdown">
                  <select
                    value={
                      childRelationShip?.find(
                        (x) => x.relationshipName == filter.relationshipName
                      )?.childSObject
                    }
                    className="form-control"
                    onChange={(event) => handleChildrenChange(index, event)}
                  >
                    <option value="">Select Child Object</option>
                    {childRelationShip.map((children, index) => (
                      <option value={children.childSObject} key={index}>
                        {children.relationshipName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col5">
                <a
                  className="closed-filter"
                  href="javascript:void(0)"
                  title="Remove this"
                  onClick={() => {
                    handleChildrenRemove(index);
                  }}
                ></a>
              </div>
            </div>
            <ul className="full-width pd-l6">
              <FilterByIdInsideCrossFilter
                index={index}
                title={filter.childSObject}
                filters={filter.filters}
                crossFilters={crossFilters}
                setCrossFilters={setCrossFilters}
              />
              <li className="d-flex">
                <div className="col1 text-center">
                  <span className="arrow-indicator"></span>
                </div>
                <div className="coll">
                  <p
                    className=" underline cursor-pointer"
                    onClick={() => {
                      handleAddCrossFilterField(index);
                    }}
                  >
                    Add Filter
                  </p>
                </div>
              </li>
            </ul>
          </li>
        ))}
      </ul>
    </>
  );
}

export default CrossFilter;
